let fontyPromise = null;

function arrayBufferNaBinaryString(buffer) {
  const bytes = new Uint8Array(buffer);
  const chunkSize = 0x8000;
  let result = '';

  for (let i = 0; i < bytes.length; i += chunkSize) {
    const chunk = bytes.subarray(i, i + chunkSize);
    result += String.fromCharCode(...chunk);
  }

  return result;
}

async function nacitajFontAkoBinaryString(url) {
  const response = await fetch(url);

  if (!response.ok) {
    throw new Error(`Nepodarilo sa načítať PDF font: ${url}`);
  }

  const buffer = await response.arrayBuffer();
  return arrayBufferNaBinaryString(buffer);
}

async function nacitajFonty() {
  if (!fontyPromise) {
    fontyPromise = Promise.all([
      nacitajFontAkoBinaryString('/fonts/Inter_24pt-Regular.ttf'),
      nacitajFontAkoBinaryString('/fonts/Inter_24pt-SemiBold.ttf'),
    ]).then(([regular, bold]) => ({
      regular,
      bold,
    }));
  }

  return fontyPromise;
}

export async function nacitajPdfFonty(pdf) {
  const { regular, bold } = await nacitajFonty();

  const fontList = pdf.getFontList?.() || {};
  const interUzExistuje = Boolean(fontList.Inter);

  if (!interUzExistuje) {
    pdf.addFileToVFS('Inter_24pt-Regular.ttf', regular);
    pdf.addFont('Inter_24pt-Regular.ttf', 'Inter', 'normal');

    pdf.addFileToVFS('Inter_24pt-SemiBold.ttf', bold);
    pdf.addFont('Inter_24pt-SemiBold.ttf', 'Inter', 'bold');
  }

  pdf.setFont('Inter', 'normal');
  pdf.setLineHeightFactor(1.28);
}